import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./APEDARegistration.css";
import "../PrivateLimitedCompany.css"

const APEDARegistration = () => {

  const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>APEDA Registration Services</h1>

        <p className="subtitle">
          Grow Your Agricultural Export Business Globally
        </p>

        <p className="desc">
          Get APEDA Registration for smooth export of food & agro products. We help exporters, manufacturers, and traders obtain APEDA registration quickly and comply with export regulations so you can expand your agricultural business internationally.
        </p>

        <div className="badges">
          <span>✔ Fast Online Registration</span>
          <span>✔ Expert Export Guidance</span>
          <span>✔ End-to-End Support</span>
          <span>✔ Hassle-Free Process</span>
        </div>

        
<div className="hero-action">
                    <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
                </div>

      </div>

      {/* WHAT IS APEDA */}
      <div className="section">
        <h2>What is APEDA?</h2>
        <p>
          Agricultural and Processed Food Products Export Development Authority (APEDA) is a government body responsible for promoting and developing exports of scheduled agricultural and processed food products from India.
        </p>
      </div>

      {/* PRODUCTS */}
      <div className="section">
        <h2>Products Covered Under APEDA</h2>
        <ul>
          <li>Fresh fruits & vegetables</li>
          <li>Meat & poultry products</li>
          <li>Dairy products</li>
          <li>Basmati rice & cereals</li>
          <li>Processed food products</li>
          <li>Honey, jaggery & confectionery</li>
          <li>Floriculture products</li>
          <li>Alcoholic beverages (wine, etc.)</li>
        </ul>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of APEDA Registration</h2>
        <ul>
          <li>Eligibility for export incentives</li>
          <li>Access to global markets</li>
          <li>Government support & subsidies</li>
          <li>Participation in trade fairs</li>
          <li>Quality certification support</li>
          <li>Increased buyer credibility</li>
        </ul>
      </div>

      {/* WHO NEEDS */}
      <div className="section">
        <h2>Who Needs APEDA Registration?</h2>
        <ul>
          <li>Exporters of agricultural products</li>
          <li>Food processing companies</li>
          <li>Agro traders</li>
          <li>Farmers exporting goods</li>
          <li>Packaging & processing units</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our APEDA Services Include</h2>
        <ul>
          <li>APEDA Registration Application</li>
          <li>Digital Signature Assistance</li>
          <li>Exporter Profile Setup</li>
          <li>Renewal & Compliance Support</li>
          <li>Documentation Guidance</li>
          <li>Linkage with IEC & export licenses</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>
        <ul>
          <li>Import Export Code (IEC)</li>
          <li>PAN Card</li>
          <li>GST Certificate</li>
          <li>Bank Account Details</li>
          <li>Business Address Proof</li>
          <li>Email & Contact Details</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>APEDA Registration Process</h2>
        <ul>
          <li>Consultation – Check eligibility</li>
          <li>Document Collection</li>
          <li>Online Application Filing</li>
          <li>Verification by authority</li>
          <li>Certificate Issuance</li>
        </ul>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Export Compliance Experts</li>
          <li>Fast Registration Process</li>
          <li>Complete Documentation Support</li>
          <li>Affordable Pricing</li>
          <li>End-to-End Assistance</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Is APEDA mandatory?</b> Yes, for scheduled agricultural exports.</p>
        <p><b>How long does it take?</b> 2–5 working days.</p>
        <p><b>Is IEC required?</b> Yes, IEC is mandatory.</p>
        <p><b>Does APEDA give benefits?</b> Yes, subsidies and export incentives.</p>

      </div>

      {/* CTA */}
      <div className="cta"  ref={contactRef}>
        <h2>Start Exporting Agro Products Globally</h2>
        <p>Get your APEDA registration done today.</p>

        <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
      </div>

    </div>
  );
};

export default APEDARegistration;